import cntl from "cntl";
import PropTypes from "prop-types";
import { TextLink } from "../atoms";
import { POSITIONS } from "../constants";

const propTypes = {
  steps: PropTypes.array,
  onClick: PropTypes.func,
  current: PropTypes.number,
  className: PropTypes.string,
};

function MenuSlider({ steps, className, current, onClick }) {
  const wrapperCn = () => cntl`
    flex
    gap-y-10
    flex-col
    sm:flex-row
    sm:justify-center
    ${className ? className : undefined}
  `;

  const itemWrapperCn = (index) => cntl`
    flex
    w-full
    flex-col
    border-t-4
    cursor-pointer
    gap-y-4
    items-center
    ${current === index ? "border-primary-light-6" : "border-gray-light-3 dark:border-gray-dark-3"}
  `;

  const textWrapperCn = (index) => cntl`
  ${!steps[index].icon && "mt-6"}
    px-4
    gap-y-2
  `;

  const titleCn = () => cntl`
    text-xl
    font-medium
    text-gray-light-12 
    dark:text-gray-dark-12
  `;

  const textCn = () => cntl`
    text-base
    text-gray-light-11 
    dark:text-gray-dark-11
  `;

  return (
    <div className={wrapperCn()}>
      {steps?.map(({ title, text, cta, icon }, index) => {
        return (
          <div key={`step-${index}`} onClick={() => onClick(index)} className={itemWrapperCn(index)}>
            {icon && <div className="mt-6 w-16 h-16">{icon}</div>}
            <div className={textWrapperCn(index)}>
              <div className={titleCn()}>{title}</div>
              <div className={textCn()}>{text}</div>
            </div>
            {cta && (
              <TextLink
                label={cta.text}
                iconPosition={POSITIONS.right}
                className="mt-1"
                to={cta?.onClick}
              />
            )}
          </div>
        );
      })}
    </div>
  );
}

MenuSlider.propTypes = propTypes;
export default MenuSlider;
